import React, { useState, useEffect, useRef } from 'react';
import useAmbientMusic from '../hooks/useAmbientMusic';
import './GlobalMusicPlayer.css';

const GlobalMusicPlayer = ({ inMenu = false }) => {
  const { isPlaying: enginePlaying, toggleMusic, currentMode, cycleMode } = useAmbientMusic();
  const [isPlaying, setIsPlaying] = useState(() => {
    return localStorage.getItem('musicPlaying') === 'true';
  });
  const audioRef = useRef(null);
  const initialSyncDone = useRef(false);

  // Initial Sync from localStorage
  useEffect(() => {
    if (!initialSyncDone.current) {
      if (isPlaying && !enginePlaying) {
        // We try to start it, but browsers will block this until first interaction
        // so we don't worry too much about it failing here.
        toggleMusic();
      }
      initialSyncDone.current = true;
    }
  }, [isPlaying, enginePlaying, toggleMusic]);

  // Handle enginePlaying changes (e.g. from toggleMusic or if engine stops itself)
  useEffect(() => {
    setIsPlaying(enginePlaying);
    localStorage.setItem('musicPlaying', enginePlaying);
  }, [enginePlaying]);

  // Handle local <audio> tag for future use or as requested by user
  useEffect(() => {
    if (enginePlaying) {
      audioRef.current?.play().catch(() => {
        // Silently handle autoplay block
      });
    } else {
      audioRef.current?.pause();
    }
  }, [enginePlaying]);

  const handleToggle = () => {
    toggleMusic();
  };

  const getModeIcon = () => {
    switch (currentMode) {
      case 'vitality': return '✨';
      case 'zen': return '🧘';
      default: return '🎵';
    }
  };

  const getModeTitle = () => {
    const action = isPlaying ? "Pausar" : "Activar";
    switch (currentMode) {
      case 'vitality': return `${action} Vitalidad`;
      case 'zen': return `${action} Zen`;
      default: return `${action} Sistema`;
    }
  };

  return (
    <div className={`music-player-container ${inMenu ? 'in-menu' : ''}`}>
      <button className="arrow-btn" onClick={() => cycleMode(-1)}>‹</button>
      <button
        className={`global-music-btn ${isPlaying ? 'playing' : ''}`}
        onClick={handleToggle}
        title={getModeTitle()}
      >
        {getModeIcon()}
      </button>
      <button className="arrow-btn" onClick={() => cycleMode(1)}>›</button>
      <audio
        ref={audioRef}
        loop
        style={{ display: 'none' }}
        src="" // No audio file found in repo, kept as requested placeholder
      />
    </div>
  );
};

export default GlobalMusicPlayer;
